const state = {
  additionalCandidates: {},
  additionalVotesNum: 25 // Additional write in votes for proxy nominations
};

const getters = {
  additionalVoteById: state => id => state.additionalCandidates[id]
};

const actions = {
  addCandidate({commit}, value) {
    return commit('UPDATE_ADDITIONAL_CANDIDATES', value);
  }
};

const mutations = {
  UPDATE_ADDITIONAL_CANDIDATES(state, {questionId, candidate}) {
    if (!state.additionalCandidates[questionId]) {
      state.additionalCandidates[questionId] = [];
    }

    state.additionalCandidates[questionId].push(candidate);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
